import { Box, Container, Grid } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Section from "./Section";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";
import * as React from "react";
import { ReactComponent as LogoSvg } from "../assets/logo.svg";

export default function WisdomQuote() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Section id="quote">
      <Container
        sx={{
          minHeight: "50vh",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          flexDirection: 'column',
          px:0
        }}
      >
        <Grid
          container
          direction="row"
          alignItems="center"
          sx={{ height: "100%", py: 6, px: 0 }}
        >
          <Box sx={{ width: "100%", px:2 }}>
            <Typography
              variant="h3"
              sx={{
                textAlign: "right",
                fontSize: { xs: "1.75rem", sm: "2rem" },
                fontWeight: 300,
                width: { xs: "90%", sm: "70%" },
                ml: "auto",
                color: "#5f2e20",
              }}
            >
              У будь-якому випадку час - це ключ до успіху. Якщо&nbsp;Ви&nbsp;правильно
              його&nbsp;інвестуєте, то&nbsp;отримаєте&nbsp;все, чого&nbsp;хочете&nbsp;в&nbsp;житті.
            </Typography>
            <Typography
              variant="h3"
              sx={{
                textAlign: "left",
                mt: 2,
                fontSize: { xs: "1.1rem", sm: "1.3rem" },
                fontWeight: 100,
                ml: "unset",
                width: { xs: "90%", sm: "70%" },
                mr: "auto",
                color: "#5f2e20",
                fontStyle: "italic",
              }}
            >
              Якщо Ви не зможете правильно&nbsp;його&nbsp;інвестувати, Ви&nbsp;ніколи&nbsp;не&nbsp;отримаєте&nbsp;того, чого&nbsp;хочете.
            </Typography>
          </Box>
        </Grid>
        <Box
          sx={{
            zIndex: 99,
            mt: 9
          }}
        >
          <Box
            sx={{
              animation: "pulse 2s infinite",
              transformOrigin: "center",

              "@keyframes pulse": {
                "0%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.12)" },
                "100%": { transform: "scale(1)" },
              },
            }}
          >
            <LogoSvg
              style={{
                width: "6rem",
                height: "6rem",
                display: "block",
              }}
            />
          </Box>
        </Box>
      </Container>
    </Section>
  );
}
